import React from 'react';

const TarifaContext = React.createContext();

export default TarifaContext;